module.exports = __webpack_public_path__ + "img/iphone-charging-FRANCE-fr.787473c5.webp";